module.exports = __webpack_public_path__ + "img/LV2.125cf2d8.webp";